<div class="po-xl-3 po-lg-3 po-md-3 po-sm-3">
    <div>
      <span class="cp-title-widget-green" style="text-align: left;">{{ labelContratadoLiberado }}</span>
    </div>
    <p class="po-text-center cp-font-bold cp-text-taskContrats">
      {{ taskitem.getFormattedNumber(valorContratadoouMedido) }}</p>
    <p class="cp-font-bold" style="text-align: center;">{{ literalsCp?.strTotal }}</p>
</div>

<div class="po-xl-1 po-lg-1 po-md-1 po-sm-1 cp-div-pipe"></div>

<div class="po-xl-4 po-lg-4 po-md-4 po-sm-4">
  <div class="po-xl-7 po-lg-7 po-md-7 po-sm-7" style="margin-top: 30px;white-space: nowrap; width: fit-content;">
      <p style="line-height: 1;"><span class="cp-font-bold" style="font-size: 14px;">{{ labelStartLegend + ': ' }}</span><span
          class="cp-font-normal">{{ taskitem.getFormattedNumber(valorStart) }}</span>
        <br>
        <span class="cp-font-bold" style="font-size: 14px;">{{ labelEndLegend + ':' }} </span><span
          class="cp-font-normal">{{ taskitem.getFormattedNumber(valorEnd) }}</span>
      </p>
    </div>

    <div class="po-xl-3 po-lg-3 po-md-3 po-sm-3" style="margin-left: 8px;">
      <cp-gauge class="cp-font-normal" [value]="percentageChartGauge"
        [startlegend]="labelStartLegend" [endlegend]="labelEndLegend"></cp-gauge>
    </div>
</div>

<div>
  <div class="po-xl-1 po-lg-1 po-md-1 po-sm-1 cp-div-pipe"></div>

  <div class="po-xl-4 po-lg-4 po-md-4 po-sm-4">
    <div class="po-row">
      <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12 cp-np" style="line-height: normal;">
        <div class="po-xl-6 po-lg-6 po-md-6 po-sm-6 cp-np" style="text-align: left; height: fit-content;">
          <span class="cp-font-bold" style="font-size: 10px; color: #277099">{{ literalsCp?.strPago }}</span>
        </div>
        <div class="po-xl-6 po-lg-6 po-md-6 po-sm-6 cp-np" style="text-align: right; height: fit-content;">
          <span class="cp-font-bold" style="font-size: 10px;">{{ literalsCp?.strLiberado }}</span>
        </div>
      </div>
      <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12 cp-np">
        <cp-progresschart [percent]="TaskContract.percentagePaidUnderReleased" ></cp-progresschart>
      </div>
      <div class="po-xl-12 po-lg-12 po-md-12 po-sm-12 cp-np" style="line-height: normal;">
        <div class="po-xl-6 po-lg-6 po-md-6 po-sm-6 cp-np" style="text-align: left; height: fit-content;">
          <span class="cp-font-bold" style="font-size: 10px; color: #277099">{{ taskitem.getFormattedNumber(TaskContract.amountPaid )}}</span>
        </div>
        <div class="po-xl-6 po-lg-6 po-md-6 po-sm-6 cp-np" style="text-align: right; height: fit-content;">
          <span class="cp-font-bold" style="font-size: 10px;">{{ taskitem.getFormattedNumber(TaskContract.amountReleased )}}</span>
        </div>
      </div>
    </div>
    <div class="po-row" style="margin-top: 10px;">
      <span class="cp-div-rectangle">
        <span style="font-size: 14px;">{{ literalsCp?.strSaldoAPagar | lowercase }}</span>
      </span>
      <span class="cp-font-bold" style="margin-left: 7px">{{ taskitem.getFormattedNumber(TaskContract.balanceToPay)}}</span>
    </div>
  </div>
</div>

<po-loading-overlay [hidden]="isHideLoading" p-size="sm">
</po-loading-overlay>

